const PIXEL_ID = '2613728391791'

function generatePixel() {
  /* prettier-ignore */
  // eslint-disable-next-line no-unused-expressions, no-sequences
  !function(e){if(!window.pintrk){window.pintrk = function () { window.pintrk.queue.push(Array.prototype.slice.call(arguments))};const n=window.pintrk;n.queue=[],n.version="3.0";const t=document.createElement("script");t.async=!0,t.src=e;const r=document.getElementsByTagName("script")[0]; r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
}

export default function ({ app, store, isDev }) {
  generatePixel()
  load(store.state.user.details)
  window.pintrk('page')

  app.$bus.$on('lead', () => track('lead'))
  app.$bus.$on('register', user => {
    set(user.email)
    track('signup')
  })
  app.$bus.$on('login', user => set(user.email))
  app.$bus.$on('view-product', productId =>
    track('pagevisit', {
      product_id: productId
    })
  )
  app.$bus.$on('add-cart', product =>
    track('addtocart', {
      value: product.amount,
      order_quantity: 1,
      currency: 'USD',
      line_items: [
        {
          product_name: product.name,
          product_id: product.id
        }
      ]
    })
  )

  function load(user) {
    const userOptions = user.id ? { em: user.email } : {}

    if (isDev) console.log('[pinterest] load', userOptions)
    window.pintrk('load', PIXEL_ID, userOptions)
  }

  function set(em) {
    if (!em) return
    if (isDev) console.log('[pinterest] set', em)
    window.pintrk('set', { em })
  }

  function track(eventName, payload = {}) {
    if (isDev) console.log('[pinterest] track', eventName, payload)
    window.pintrk('track', eventName, payload)
  }
}
